import React from "react";

function DashMessage() {
  return <div>Mesage</div>;
}

export default DashMessage;
